import React from 'react';

// Professional Shield/Badge Logo
const LogoOption4 = ({ className = "" }) => {
  return (
    <svg
      viewBox="0 0 200 200"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="logo4Gradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#10b981', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#047857', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      
      {/* Shield shape */}
      <path
        d="M 100 15 L 170 45 L 170 110 Q 170 155 100 185 Q 30 155 30 110 L 30 45 Z"
        fill="url(#logo4Gradient)"
      />
      
      {/* Inner shield border */}
      <path
        d="M 100 35 L 150 55 L 150 105 Q 150 135 100 155 Q 50 135 50 105 L 50 55 Z"
        fill="none"
        stroke="white"
        strokeWidth="2"
        opacity="0.3"
      />
      
      {/* TYJ Letters with nice spacing */}
      <text
        x="100"
        y="105"
        fontFamily="Arial, sans-serif"
        fontSize="50"
        fontWeight="bold"
        fill="white"
        textAnchor="middle"
        dominantBaseline="middle"
        letterSpacing="4"
      >
        TYJ
      </text>
      
      {/* Top accent line */}
      <line x1="70" y1="70" x2="130" y2="70" stroke="white" strokeWidth="2" opacity="0.6" />
      
      {/* Bottom accent */}
      <text
        x="100"
        y="140"
        fontFamily="Arial, sans-serif"
        fontSize="10"
        fontWeight="600"
        fill="white"
        textAnchor="middle"
        opacity="0.8"
        letterSpacing="2"
      >
        GROUP
      </text>
    </svg>
  );
};

export default LogoOption4;